module.exports = __webpack_public_path__ + "static/media/cancel-small-icon.93e8468f.svg";